import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

@Module({
  name: "bgm",
  stateFactory: true,
  namespaced: true
})
export default class BgmStore extends VuexModule {
  bgmUrl: string = '/sounds/bgm.mp3';
  isBgmPlaying: boolean = false;
  isBgmMuted: boolean = true;
  
  @Mutation
  playBgm (): void {
    if (!this.isBgmMuted) {
      this.isBgmPlaying = true;
    }
  }
  
  @Mutation
  pauseBgm (): void {
    if (this.isBgmPlaying) {
      this.isBgmPlaying = false;
    }
  }
  
  @Mutation
  toggleBgm ({ toggle }): void {
    if (toggle) {
      this.isBgmMuted = false;
      this.isBgmPlaying = true;
    }
    else {
      this.isBgmMuted = true;
      this.isBgmPlaying = false;
    }
  }
}
